import { AuthorizationState } from '@Types'
import {
  hasCashJournalApiPermissions,
  hasAchTransfersAccess,
  hasAchUiPermissions,
  hasWireTransfersAccess,
  hasWireUiPermissions,
  hasCashJournalUiPermissions,
  hasCheckTransfersAccess,
  hasCheckUiPermissions,
  hasCheckOvernightToApexPermissions,
  hasCashTransferPositionJournalReadPermissions,
  hasCashTransferPositionJournalUpdatePermissions
} from '../../utils/permissionsHelper'

interface ReadTransferSelectPermissions {
  hasAch: boolean
  hasCashJournal: boolean
  hasWire: boolean
  hasCheck: boolean
  hasPositionJournal: boolean
}

interface WriteTransferSelectPermissions extends ReadTransferSelectPermissions {
  hasCheckOvernightToApex: boolean
}

export const getViewPermissions = (auth: AuthorizationState): ReadTransferSelectPermissions => {
  const permissionsList = auth?.authorization?.permissions
  const hasCashJournal = hasCashJournalUiPermissions(permissionsList)
  const hasAch = hasAchUiPermissions(permissionsList)
  const hasWire = hasWireUiPermissions(permissionsList)
  const hasCheck = hasCheckUiPermissions(permissionsList)
  const hasPositionJournal = hasCashTransferPositionJournalReadPermissions(permissionsList)

  return {
    hasAch,
    hasCashJournal,
    hasWire,
    hasCheck,
    hasPositionJournal
  }
}

export const getWritePermissions = (auth: AuthorizationState): WriteTransferSelectPermissions => {
  const permissionsList = auth?.authorization?.permissions
  const hasCashJournal = hasCashJournalApiPermissions(permissionsList)
  const hasAch = hasAchTransfersAccess(permissionsList)
  const hasWire = hasWireTransfersAccess(permissionsList)
  const hasCheck = hasCheckTransfersAccess(permissionsList)
  const hasCheckOvernightToApex = hasCheckOvernightToApexPermissions(permissionsList)
  const hasPositionJournal = hasCashTransferPositionJournalUpdatePermissions(permissionsList)

  return {
    hasCashJournal,
    hasAch,
    hasWire,
    hasCheck,
    hasPositionJournal,
    hasCheckOvernightToApex
  }
}
